import { StyleSheet, Text, View } from '@react-pdf/renderer'
import moment from 'moment'

import { MesureResponseModel } from '@/domain/model/measures'
import { getCurrentQuestionById } from '@/pages/ClientDetails/ClientMeasures/utils/getCurrentQuestionById'
import { transformLevelsToCategories } from '@/pages/ClientDetails/ClientMeasures/utils/transformLevelsToCategories'

import { globalPDFStyles } from '../../styles'

const styles = StyleSheet.create({
  table: {
    width: '100%',
    border: '1pt solid #e0e0e0',
    borderRadius: 4,
    overflow: 'hidden',
    marginTop: 10,
  },
  tableRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  tableHeader: {
    backgroundColor: '#f9f9f9',
    fontWeight: 'bold',
    fontSize: 10,
    color: '#333',
  },
  tableCell: {
    fontSize: 10,
    paddingVertical: 6,
    paddingHorizontal: 8,
  },
  dateCell: {
    width: '20%',
    textAlign: 'left',
  },
  notesCell: {
    width: '40%',
    textAlign: 'left',
  },
  scoreCell: {
    width: '20%',
    textAlign: 'center',
  },
  levelCell: {
    alignItems: 'center',
    width: '20%',
    textAlign: 'center',
  },
  rowBorder: {
    borderTop: '1pt solid #e0e0e0',
  },
  levelBadge: {
    borderRadius: 14,
    fontSize: 8,
    paddingHorizontal: 6,
    paddingVertical: 2,
    fontWeight: 600,
    backgroundColor: '#fce4ec',
  },
})

type Props = {
  measureData?: MesureResponseModel
  questionId: string
}
export const MeasurePDFTable = ({ measureData, questionId }: Props) => {
  const currentQuestion = getCurrentQuestionById({
    data: measureData,
    questionId,
  })

  const levels = transformLevelsToCategories(currentQuestion?.levels)

  return (
    <>
      <Text style={globalPDFStyles.paragraphTitle}>Table History</Text>
      <View style={styles.table}>
        <View style={[styles.tableRow, styles.tableHeader]}>
          <Text style={[styles.tableCell, styles.dateCell]}>Date</Text>
          <Text style={[styles.tableCell, styles.notesCell]}>Notes</Text>
          <Text style={[styles.tableCell, styles.scoreCell]}>Score</Text>
          <Text style={[styles.tableCell, styles.levelCell]}>Level</Text>
        </View>

        {currentQuestion?.measures.map((item, index) => {
          const level = levels?.(Number(item.answer_value))
          return (
            <View key={index} style={[styles.tableRow, styles.rowBorder]}>
              <Text style={[styles.tableCell, styles.dateCell]}>
                {moment(item.answer_date, 'YYYY-MM-DD').format('MM/DD/YYYY')}
              </Text>
              <Text style={[styles.tableCell, styles.notesCell]}>
                {item.notes}
              </Text>
              <Text style={[styles.tableCell, styles.scoreCell]}>
                {Number(item.answer_value)}
              </Text>
              <View style={[styles.tableCell, styles.levelCell]}>
                <View
                  style={[
                    styles.levelBadge,
                    { backgroundColor: `${level?.color}30` },
                  ]}
                >
                  <Text style={{ color: level?.color }}>{level?.label}</Text>
                </View>
              </View>
            </View>
          )
        })}
      </View>
    </>
  )
}
